import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const MARGIN = 32;

/** Rasterize a DOM node and paginate it onto A4 pages. */
export async function exportNodeToPdf(node, filename) {
  const canvas = await html2canvas(node, {
    scale: 2, useCORS: true, backgroundColor: "#ffffff", windowWidth: node.scrollWidth,
  });
  const pdf = new jsPDF({ orientation: "p", unit: "pt", format: "a4" });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageBody = pdf.internal.pageSize.getHeight() - MARGIN * 2;
  const usableWidth = pageWidth - MARGIN * 2;
  const imgHeight = canvas.height * (usableWidth / canvas.width);
  const imgData = canvas.toDataURL("image/jpeg", 0.92);

  pdf.addImage(imgData, "JPEG", MARGIN, MARGIN, usableWidth, imgHeight);
  for (let heightLeft = imgHeight - pageBody; heightLeft > 0; heightLeft -= pageBody) {
    pdf.addPage();
    pdf.addImage(imgData, "JPEG", MARGIN, heightLeft - imgHeight + MARGIN, usableWidth, imgHeight);
  }
  pdf.save(filename);
}
